module.exports = __webpack_public_path__ + "img/bag.758a2bc0.svg";